import { useEffect } from 'react';
import { usePreferencesStore } from '../../store/preferences-store';
import { BOARD_THEME_COLORS } from './board-themes';

export default function BoardThemeApplier(): null {
  const boardTheme = usePreferencesStore((s) => s.boardTheme);
  const customLight = usePreferencesStore((s) => s.customBoardLight);
  const customDark = usePreferencesStore((s) => s.customBoardDark);

  useEffect(() => {
    const root = document.documentElement;
    // 'auto' = per-variant: clear global overrides so boards self-scope their
    // variant colors and other UI falls back to the index.css default.
    if (boardTheme === 'auto') {
      root.style.removeProperty('--color-square-light');
      root.style.removeProperty('--color-square-dark');
      return;
    }
    // I colori personalizzati passano di qui come qualunque tema: se restassero fuori,
    // le scacchiere li userebbero ma il resto della UI che legge queste variabili
    // (coordinate, mini-scacchiere) resterebbe al tema precedente.
    const colors =
      boardTheme === 'custom'
        ? { light: customLight, dark: customDark }
        : BOARD_THEME_COLORS[boardTheme];
    if (!colors) return;
    root.style.setProperty('--color-square-light', colors.light);
    root.style.setProperty('--color-square-dark', colors.dark);
  }, [boardTheme, customLight, customDark]);

  return null;
}
